<template>
  <v-card
    class="ma-0"
    width="100%"
    style="border-radius: 4px; min-height: 111px !important; border: 1px solid #e3e3e3"
    flat
  >
    <v-app-bar flat class="my-0 mb-4 py-1 px-4" dense height="36">
      <v-toolbar-title> {{ $t("quickAccessToCustomer") }}</v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" lazy-validation>
      <v-container fluid class="px-1 py-2">
        <v-row>
          <v-col cols="12" md="12" class="mb-3">
            <search-customer
              v-model="customer"
              :show-dashboard="true"
              @go-dashboard="$emit('go-dashboard')"
            />
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" class="customer-desk-tabs-col">
            <v-tabs class="customer-desk-tabs" height="40">
              <v-tab
                v-for="(item, i) in components"
                :key="i"
                v-show="
                  $store.state.permissions &&
                  $store.state.permissions.length > 0 &&
                  $store.state.permissions.includes(item.to)
                "
              >
                {{ $t(item.name) }}
              </v-tab>
              <v-tab-item
                v-for="(item, i) in components"
                :key="i"
                v-show="
                  $store.state.permissions &&
                  $store.state.permissions.length > 0 &&
                  $store.state.permissions.includes(item.to)
                "
              >
                <div class="customer-desk-tab-body">
                  <component
                    :is="item.component"
                    :id-prop="null"
                    :account-prop="customer"
                    :not-store="null"
                    :type-prop="item.type"
                  />
                </div>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import searchCustomer from "./personsSerach";
import General from "../../../../Mixins/general";
import invoiceList from "../invoice/list";
import turnover from "../accounting/turnover";
import task from "../task/list";
export default {
  name: "Product",
  components: {
    searchCustomer,
    invoiceList,
    task,
    turnover,
  },
  mixins: [General],
  props: ["formType"],
  data: () => ({
    render: true,
    customer: null,
    components: [
      {
        component: "invoiceList",
        name: "sell",
        to: "sellList",
        type: "sell",
      },
      {
        component: "invoiceList",
        to: "purchaseList",
        name: "purchase",
        type: "purchase",
      },
      {
        component: "invoiceList",
        to: "presaleList",
        name: "presale",
        type: "presale",
      },
      {
        component: "turnover",
        to: "turnover",
        name: "turnover",
        type: "turnover",
      },
      {
        component: "task",
        to: "TaskList",
        name: "relatedTasks",
        type: "related",
      },
      {
        component: "task",
        to: "TaskList",
        name: "participantTasks",
        type: "participants",
      },
    ],
  }),
  watch: {
    customer(val) {},
  },
  beforeMount() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.customer-desk-tabs-col {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.customer-desk-tab-body {
  padding-top: 4px;
  padding-bottom: 8px;
}
/* Align tab content (inputs/table) with tab labels on the start edge */
.customer-desk-tab-body ::v-deep > .v-card {
  padding-inline: 0 !important;
}
.customer-desk-tab-body ::v-deep > .v-card > .v-toolbar,
.customer-desk-tab-body ::v-deep > .v-card > .v-app-bar {
  padding-inline: 0 !important;
}
.customer-desk-tab-body ::v-deep > .v-card > .v-toolbar .v-toolbar__content,
.customer-desk-tab-body ::v-deep > .v-card > .v-app-bar .v-toolbar__content {
  padding-inline: 0 !important;
}
.customer-desk-tab-body ::v-deep > .v-card > .col,
.customer-desk-tab-body ::v-deep > .v-card > .v-col {
  padding-inline: 0 !important;
}
.customer-desk-tab-body ::v-deep .v-chip-group .v-slide-group__content {
  padding-inline: 0 !important;
}
.customer-desk-tabs ::v-deep .v-tabs-bar {
  margin-inline: 0;
}
.customer-desk-tabs ::v-deep .v-slide-group__content {
  padding-inline-start: 0;
}
</style>
